module.exports = __webpack_public_path__ + "img/featured-image.c4cc6527.jpg";